<template>
  <div>
    <form class="p-0">
      <div class="row">
        <div
          v-for="(item, index) in docs"
          :key="index"
          class="col-12 col-md-4 d-flex justify-content-center mb-4"
          data-wow-delay="0.2s"
        >
          <div
            class="card border shadow-lg p-2 justify-content-around w-100 mb-1 mt-1 pl-0 pr-0"
            style="border-width: 2.5px !important; max-width: 350px"
            :class="getClass(item, index)"
          >
            <div class="rounded-top">
              <file-pond
                name="test"
                :ref="'filePond' + index"
                :label-idle="
                  !item.url_file
                    ? 'Agrega el documento aquí'
                    : 'Agrega el documento a actualizar'
                "
                accepted-file-types="image/jpeg, image/png, image/jpg, application/pdf"
                :server="null"
                :files="item.file ? [item.file] : []"
                @updatefiles="updateFiles(index, $event)"
              />
            </div>
            <div class="rounded-bottom px-3 py-3">
              <p class="mb-1">
                <span><b>Tipo de documento:</b> {{ item.type }}</span>
              </p>
              <p class="mb-1">
                <span
                  ><b>Creado: </b
                  >{{
                    item.created_at.split(' ')[0].split('-').reverse().join('-')
                  }}</span
                >
              </p>
              <p class="mb-1">
                <span
                  ><b>Modificado: </b
                  >{{
                    item.updated_at.split(' ')[0].split('-').reverse().join('-')
                  }}</span
                >
              </p>
              <div v-if="item.expiration_date !== null">
                <label for=""><b>Fecha de expiración:</b></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="item.expiration_date"
                />
              </div>
              <div
                class="w-100 d-flex justify-content-between align-items-center"
                v-if="item.url_file && item.url_file !== ''"
              >
                <i class="h3 bi-file-earmark-check text-success"></i>
                <div>
                  <button
                    @click.prevent="viewFile(item.url_file)"
                    class="btn btn-primary btn-fill pt-1 pb-1 mr-2"
                  >
                    <i class="h4 bi-eye"></i>
                  </button>
                  <button
                    @click.prevent="deleteDocument(index)"
                    class="btn btn-danger btn-fill pt-1 pb-1"
                  >
                    <i class="h4 bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mb-2 d-flex justify-content-center">
        <button
          @click.prevent="saveDocuments()"
          class="btn btn-primary mt-2 w-50 btn-fill"
        >
          Actualizar documentos
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  components: {
    FilePond
  },
  data() {
    return {
      docs: [
        {
          id: 0,
          type: 'RIF',
          file: '',
          url_file: '',
          expiration_date: 'missing',
          created_at: '',
          updated_at: '',
          exists: false
        },
        {
          id: 0,
          type: 'Registro de Comercio',
          file: '',
          url_file: '',
          expiration_date: null,
          created_at: '',
          updated_at: '',
          exists: false
        },
        {
          id: 0,
          type: 'Registro Mercantil',
          file: '',
          url_file: '',
          expiration_date: 'missing',
          created_at: '',
          updated_at: '',
          exists: false
        },
        /*
        {
          id: 0,
          type: 'NIT',
          file: '',
          url_file: '',
          created_at: '',
          updated_at: '',
          exists: false
        },
        */
        {
          id: 0,
          type: 'Cédula del representante legal 1',
          file: '',
          url_file: '',
          expiration_date: 'missing',
          created_at: '',
          updated_at: '',
          exists: false
        },
        {
          id: 0,
          type: 'Cédula del representante legal 2',
          file: '',
          url_file: '',
          expiration_date: 'missing',
          created_at: '',
          updated_at: '',
          exists: false
        },
        {
          id: 0,
          type: 'Cédula del representante legal 3',
          file: '',
          url_file: '',
          expiration_date: 'missing',
          created_at: '',
          updated_at: '',
          exists: false
        },
        {
          id: 0,
          type: 'Cédula del representante legal 4',
          file: '',
          url_file: '',
          expiration_date: 'missing',
          created_at: '',
          updated_at: '',
          exists: false
        }
      ]
    }
  },
  created() {
    this.loadDocuments()
  },
  methods: {
    ...mapActions([
      'getData',
      'updateData',
      'createData',
      'changeStatusData',
      'optimizeImage'
    ]),

    async loadDocuments() {
      try {
        const response = await this.getData({
          url: 'user_file/all',
          params: { id_user: this.$route.params.id }
        })
        if (response.code === 200 && response.data) {
          console.log('Cargando documentos...')
          response.data.forEach((item) => {
            const docIndex = this.docs.findIndex(
              (doc) => doc.type === item.title
            )
            if (docIndex !== -1) {
              this.docs[docIndex].id = item.id || 0
              this.docs[docIndex].url_file = item.url_image || ''
              this.docs[docIndex].created_at = item.created_at || ''
              this.docs[docIndex].updated_at = item.updated_at || ''
              this.docs[docIndex].expiration_date = item.expiration_date || ''
              this.docs[docIndex].exists = true
            }
          })
        }
      } catch (error) {
        console.error('Error al cargar documentos:', error)
      }
    },

    updateFiles(index, fileItems) {
      this.docs[index].file = fileItems.length ? fileItems[0].file : ''
    },

    viewFile(url) {
      window.open(url, '_blank')
    },

    async saveDocuments() {
      const { value } = await Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar los documentos?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, guardar'
      })

      if (!value) return

      const uploadedDocs = []
      const failedDocs = []

      await Promise.all(
        this.docs.map(async (element, index) => {
          const filePondInstance = this.$refs[`filePond${index}`][0].getFiles()

          if (filePondInstance.length === 0 || !filePondInstance[0].file) {
            failedDocs.push(element.type)
            return
          }

          const formData = new FormData()
          formData.append('title', element.type)
          formData.append('id_user', this.$route.params.id)

          const compressedImage = await this.optimizeImage(
            filePondInstance[0].file
          )
          formData.append('url_image', compressedImage)

          try {
            const expirationDate = element.expiration_date || ''
            if (expirationDate === 'missing') {
              console.log('expiracion:', expirationDate)

              await Swal.fire({
                title: 'Advertencia',
                text: `El archivo ${element.type} requiere una fecha de expiración. Por favor, ingrese una fecha válida.`,
                icon: 'warning',
                confirmButtonText: 'Entendido'
              })
              failedDocs.push(element.type)
            } else {
              if (element.exists) {
                await this.updateData({
                  url: 'user_file/update',
                  id: element.id,
                  data: formData
                })
              } else {
                await this.createData({ url: 'user_file/save', data: formData })
              }
              uploadedDocs.push(element.type)
            }
          } catch (error) {
            console.error(
              `Error al guardar el documento ${element.type}:`,
              error
            )
            failedDocs.push(element.type)
          }
        })
      )

      this.showSaveResult(uploadedDocs, failedDocs)
    },

    showSaveResult(uploadedDocs, failedDocs) {
      let title
      let message
      let icon

      if (failedDocs.length === 0) {
        title = 'Documentos guardados correctamente'
        message = `Documentos guardados: ${uploadedDocs.join(',')}`
        icon = 'success'
      } else if (uploadedDocs.length === 0) {
        title = 'Advertencia'
        message = `Documentos que faltan por guardar: ${failedDocs.join(',')}`
        icon = 'warning'
      } else {
        title = 'Documentos actualizados correctamente'
        message = `Documentos actualizados: ${uploadedDocs.join(', ')}`
        icon = 'success'
      }

      Swal.fire({
        title,
        text: message,
        icon,
        confirmButtonText: 'Aceptar',
        customClass: {
          container: 'font-size-sm'
        }
      }).then(() => {
        this.clearFilePondRefs()
        this.loadDocuments()
      })
    },

    async deleteDocument(index) {
      await Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de eliminar este documento?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, eliminar'
      }).then(async (result) => {
        if (result.value) {
          console.log('Eliminando documento...')
          const form = {
            url: 'user_file/change_status',
            id: this.docs[index].id,
            status: 2
          }
          await this.changeStatusData(form).then(async (response) => {
            if (response.code === 200) {
              Swal.fire({
                title: 'Documento eliminado correctamente',
                icon: 'success',

                confirmButtonText: 'Aceptar'
              })
            } else {
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al eliminar el documento.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            }
          })
          this.clearFilePondRefs()
          this.loadDocuments()
        }
      })
    },
    clearFilePondRefs() {
      this.docs.forEach((element, index) => {
        this.$refs['filePond' + index][0].removeFiles()
        this.docs = [
          {
            id: 0,
            type: 'RIF',
            file: '',
            url_file: '',
            expiration_date: 'missing',
            created_at: '',
            updated_at: '',
            exists: false
          },
          {
            id: 0,
            type: 'Registro de Comercio',
            file: '',
            url_file: '',
            expiration_date: null,
            created_at: '',
            updated_at: '',
            exists: false
          },
          {
            id: 0,
            type: 'Registro Mercantil',
            file: '',
            url_file: '',
            expiration_date: 'missing',
            created_at: '',
            updated_at: '',
            exists: false
          },
          /*
          {
            id: 0,
            type: 'NIT',
            file: '',
            url_file: '',
            created_at: '',
            updated_at: '',
            exists: false
          },
          */
          {
            id: 0,
            type: 'Cédula del representante legal 1',
            file: '',
            url_file: '',
            expiration_date: 'missing',
            created_at: '',
            updated_at: '',
            exists: false
          },
          {
            id: 0,
            type: 'Cédula del representante legal 2',
            file: '',
            url_file: '',
            expiration_date: 'missing',
            created_at: '',
            updated_at: '',
            exists: false
          },
          {
            id: 0,
            type: 'Cédula del representante legal 3',
            file: '',
            url_file: '',
            expiration_date: 'missing',
            created_at: '',
            updated_at: '',
            exists: false
          },
          {
            id: 0,
            type: 'Cédula del representante legal 4',
            file: '',
            url_file: '',
            expiration_date: 'missing',
            created_at: '',
            updated_at: '',
            exists: false
          }
        ]
      })
    },
    getClass(item, index) {
      let hasFilesInPond = false

      if (this.$refs['filePond' + index] && this.$refs['filePond' + index][0]) {
        hasFilesInPond = this.$refs['filePond' + index][0].getFiles().length > 0
      }

      if (item.url_file) {
        return {
          'border-success': !hasFilesInPond,
          'border-info': hasFilesInPond,
          'bg-success-document': !hasFilesInPond,
          'bg-info-document': hasFilesInPond
        }
      } else {
        return {
          'border-danger': !hasFilesInPond,
          'border-info': hasFilesInPond,
          'bg-danger-document': !hasFilesInPond,
          'bg-info-document': hasFilesInPond
        }
      }
    }
  }
}
</script>

<style>
.font-size-sm {
  font-size: 0.75rem !important;
}

.bg-info-document {
  background-color: #1fb7f30a !important;
}
.bg-success-document {
  background-color: #86cb1609 !important;
}
.bg-danger-document {
  background-color: #e460640c !important;
}
</style>
